"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M20.19 4H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.81-2-1.81-2m-2.46 9.3-8.49 2.26c-.22.06-.45-.04-.56-.23l-1.12-1.95c-.18-.3-.01-.69.32-.78.16-.04.34-.01.47.1l1.05.82 2.39-.64L9.9 9.6c-.26-.44-.02-1.01.47-1.15.26-.07.54 0 .74.18l3.69 3.44 2.44-.65c.51-.14 1.04.17 1.18.68.13.52-.17 1.05-.69 1.2"
}), 'AirplaneTicketRounded');